import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuComponent } from './menu.component';
import { MenuService } from './menu.service';
import { OverlayLoadingComponent } from '../utilities/overlay-loading/overlay-loading.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';




@NgModule({
  declarations: [MenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatSnackBarModule,
    OverlayLoadingComponent,
  ],
  providers :  [MenuService],
  exports : [MenuComponent]
})
export class MenuModule { }
